var _style, _line, _line2, _line3, _line4, _line5, _line6, _polyline, _polyline2, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.outer-circle{fill:#FAFAFA;stroke:#F2F2F2;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#DADEDE;stroke-miterlimit:10;}\n\t.st2{fill:#2C3838;}\n\t.st3{fill:#556262;}\n\t.st4{fill:#9DA4A4;}\n\t.st5{fill:#DADEDE;}\n\t.st6{fill:#5DD9C5;}\n\t.st7{fill:#18A795;}\n\t.st8{fill:#93FFF8;}\n\t.st9{fill:none;stroke:#9DA4A4;stroke-miterlimit:10;}\n\t.st10{fill:#FFFFFF;stroke:#9DA4A4;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#2C3838;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;stroke:#9DA4A4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:#5DD9C5;stroke:#18A795;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st15{fill:#5DD9C5;stroke:#2C3838;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:#DADEDE;stroke:#556262;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#556262;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st19{fill:#FFFFFF;}\n\t.st20{fill:#5DD9C5;stroke:#9DA4A4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#9DA4A4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#9DA4A4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#556262;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#556262;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 21,
    y1: 36,
    x2: 55,
    y2: 36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 24,
    y1: 28,
    x2: 26,
    y2: 44
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 31,
    y1: 28,
    x2: 32,
    y2: 44
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 38,
    y1: 28,
    x2: 38,
    y2: 44
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 45,
    y1: 28,
    x2: 44,
    y2: 44
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 52,
    y1: 28,
    x2: 50,
    y2: 44
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "10,22 18,22 24,48 53,48 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "19,28 57,28 53,44 23,44 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 27,
    cy: 54,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 54,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50,
    cy: 54,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 50,
    cy: 54,
    r: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateCart);
export default __webpack_public_path__ + "static/media/Empty-State-Cart.323b0bd55baafb5b8330acb68c4832b5.svg";
export { ForwardRef as ReactComponent };